import { currencyFormatter } from "../../api/Functions";
import Checkbox from "../UI/Checkbox";
import style from "./BankCheckbox.module.css";
import Card from "../UI/Card";
import Callout from "../UI/Callout";

export default function BankCheckbox({ bank, name, value, disabled }) {
  const card = (
    <Card padding={"md"}>
      <div className={style.nomBank}>
        {bank.bank_metadata?.logo && (
          <img src={bank.bank_metadata.logo} alt={bank.bank_metadata.name} />
        )}
        <p>{bank.bank_metadata?.name || bank.nom || "Compte"}</p>
      </div>
      <div className="flex space-between wrap gap10">
        <div>
          <p className={style.montantLabel}>Solde</p>
          <p className={style.montant}>{currencyFormatter(bank.montant)}</p>
        </div>
      </div>
      {bank.account_type === "CARD" && (
        <Callout variant="warning">
          Ceci est le compte de votre carte de paiement différé. Selon les
          banques, il est possible que des transactions apparaissent en double,
          une sur ce compte carte, l'autre sur le compte courant.
        </Callout>
      )}
    </Card>
  );
  return (
    <>
      {disabled && card}
      {!disabled && (
        <Checkbox name={name} value={value} className={style.checkbox}>
          {card}
        </Checkbox>
      )}
    </>
  );
}
